import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import Tabs from "@/common/components/Tabs";
import { useParams } from "react-router-dom";
import { billingBillTabs } from "../../constants/tabs.constant";
import useBillingBill from "../../hooks/useBillingBill";

interface BillingBillsShowProps {
  billType?: string;
  needSupplyAuthorization?: boolean
  notFoundFallback?: string
  notFoundButtonText?: string
}

const BillingBillsShow = ({ billType, needSupplyAuthorization, notFoundFallback, notFoundButtonText }: BillingBillsShowProps) => {
  const { billId } = useParams();

  const {
    error: billError = {} as any,
    refetch: billRefetch,
  } = useBillingBill({ id: billId });

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-128px)]"
      statusCode={billError?.status}
      refetchFunction={billRefetch}
      notFoundFallback={notFoundFallback}
      notFoundButtonText={notFoundButtonText}
    >
      <Tabs
        tabsListClassName="w-full bg-transparent rounded-none"
        tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
        tabsContentClassName="mt-6"
        tabsList={billingBillTabs({ billType, needSupplyAuthorization })}
      />
    </ErrorMessageWrapper>
  );
};

export default BillingBillsShow;
